/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path="../../types/global.d.ts" />
import { BUITheme } from "@blofin/blofin-ui";
import { FC, lazy, useEffect } from "react";
import { createFooter } from "../Footer/entry";
import useNav from "./useNav";
import { footerName } from "@/nav-localized/config";

const DevFooter = lazy(() => import("../Footer"));

const NavFooter: FC<{
  theme: BUITheme;
  apiConfig: { baseUrl: string };
  footerBgColor?: string;
  isSimple?: boolean;
  size?: "1280" | "1440";
}> = ({ theme, apiConfig, footerBgColor, isSimple = false, size }) => {
  const { sdkUrl, initFooter } = useNav();

  const footerConfig = {
    theme: theme,
    baseUrl: apiConfig.baseUrl,
    footerBgColor: footerBgColor,
    isSimple: isSimple,
    size
  };

  const initFooterCallback = () => {
    // @ts-ignore
    if (window[footerName]) {
      // @ts-ignore
      window[footerName].createFooter({ ...footerConfig, env: "client" });
    }
  };

  useEffect(() => {
    if (sdkUrl.footer) {
      initFooter(initFooterCallback);
    } else {
      if (process.env.NODE_ENV === "development") {
        createFooter(footerConfig);
      }
    }
  }, [sdkUrl.footer, theme]);

  return (
    <div className={footerName} id="footer">
      <DevFooter
        theme={theme}
        baseUrl={apiConfig.baseUrl}
        footerBgColor={footerBgColor}
        isSimple={isSimple}
        size={size}
      />
    </div>
  );
};

export default NavFooter;
